const nmpReviews = {
	'24-hour': [
		{
			title: 'Downhome Friendly, Affordable pricing, Personable Service',
			stars: 5,
			text: 'It was a pleasure to find a local, in-town rental facility that had climate-controlled units available on SelfStorage. The property and the units are VERY clean and the grounds are well-kept. The pricing was as good as some non-climate-controlled units in the area. The 24-hour access is way better than most in the area. In all my many years of having to use rental units on occasion, this was by far one of the best.',
			customerName: 'Rickie Parker RevDRx',
			createdAt: '2025-02-17',
		},
		{
			title: 'Wonderful',
			stars: 5,
			text: 'The gentleman who answered the phone for SelfStorage and rented me the storage unit was one of the nicest, most helpful people I have ever dealt with. I definitely recommend this company. He was able to get me a larger unit than I planned, and it cost less in the end. I also love the 24/7 access... gotta have it!',
			customerName: 'Amber M Aracich',
			createdAt: '2025-03-16',
		},
		{
			title: 'Competitive Pricing!',
			stars: 5,
			text: 'Finally, a storage unit that is budget-friendly! Love the fact that they have 24-hour accessibility!',
			customerName: 'Tim Beber',
			createdAt: '2024-06-03',
		},
		{
			title: 'Very friendly service',
			stars: 5,
			text: 'Very friendly service. Clean and safe. What I like the most is 24/7 access to the facility, not like most others with time limits. Good prices.',
			customerName: 'S Drummer',
			createdAt: '2022-08-23',
		},
	],
	'climate-controlled': [
		{
			title: 'Super fast and easy setup',
			stars: 5,
			text: 'Super fast and easy setup, and this was the best price I have ever gotten for storage, especially for a clean, climate-controlled indoor facility.',
			customerName: 'Jon K',
			createdAt: '2025-06-07',
		},
		{
			title: 'Same day move - life saver',
			stars: 5,
			text: 'Needed a space immediately, and the online registration on SelfStorage was easy. Then we went to move in, and they were so nice and professional, explaining everything and showing us how to get to our space the most efficient way. Very clean, and the price is comparable to the other indoor, climate-controlled locations in town.',
			customerName: 'Sharon Schulz Allen',
			createdAt: '2025-05-30',
		},
		{
			title: 'Good customer service',
			stars: 5,
			text: 'Good customer service. The young man helped me find a climate-controlled unit close to my home. He was very kind. Then a young lady called me directly from the facility to see if I wanted help setting up the account. She was very kind. The setup went very smoothly.',
			customerName: 'Paula Lerew',
			createdAt: '2025-05-22',
		},
		{
			title: 'Easy - Peasy Storage',
			stars: 5,
			text: 'I did everything online, and I was emailed my instructions for accessing my storage unit. It was as smooth as butter! My climate-controlled space was perfect, which made my move less stressful. Thank you!',
			customerName: 'Katrina',
			createdAt: '2025-03-28',
		},
	],
	'drive-up': [
		{
			title: 'Shop facilities with great useful filters',
			stars: 5,
			text: 'Very nice to be able to shop units in one place. I was blown away by the useful filters available. Not only can you choose size and floor, but it will filter for available drive-up units and online move-ins.',
			customerName: 'Thundah',
			createdAt: '2025-03-15',
		},
		{
			title: 'Professional and friendly staff…',
			stars: 5,
			text: 'Professional and friendly staff. They were very friendly, caring, and very patient with me in selecting the proper storage I needed. This location was ideal for me as well. I love the drive-up — this is something many storage facilities cannot compare to as an incentive.',
			customerName: 'Linda Bellard',
			createdAt: '2024-12-19',
		},
		{
			title: 'Easy to reserve your unit...',
			stars: 5,
			text: 'Easy to reserve your unit and pay for everything up front, so I can drive straight to the unit when I come in for the first time.',
			customerName: 'Annette Pedus',
			createdAt: '2024-09-19',
		},
		{
			title: 'My self storage experience',
			stars: 5,
			text: 'The SelfStorage associate was very professional, knowledgeable, and helpful. I got a great deal with a 3-month discount, and the unit is nicely insulated with easy drive-up access.',
			customerName: 'Suzanne Quirk',
			createdAt: '2023-07-06',
		},
	],
	electricity: [
		{
			title: 'Great experience',
			stars: 5,
			text: 'Easy to use. I really like being able to filter by available features, since I needed a unit with electricity.',
			customerName: 'Tom D.',
			createdAt: '2014-12-15',
		},
		{
			title: 'Very Happy With The Facility & Staff',
			stars: 5,
			text: "Nice, clean, new unit. It will fit my needs perfectly. Found a unit that's $30–$70 less per month than other facilities in the area, plus my unit has power at no extra cost. I am overall very pleased.",
			customerName: 'Nate Kuck',
			createdAt: '2020-04-06',
		},
		{
			title: 'Made it easy when easy was critical!',
			stars: 5,
			text: 'It was a Friday afternoon, and I needed a space first thing Saturday. Within 40 minutes, I had a reservation. This site made it so easy to compare locations, amenities, and prices.',
			customerName: 'Cymantha E Governs',
			createdAt: '2025-05-19',
		},
		{
			title: 'SelfStorage.com exceeded my expectations',
			stars: 5,
			text: 'SelfStorage.com exceeded my expectations in every way possible. From the user-friendly interface to the extensive database of storage facilities, finding the perfect solution for my needs was a breeze. The detailed listings, including pricing, amenities, and customer reviews, provided valuable insights, ensuring I made an informed decision.',
			customerName: 'Steven Thorson',
			createdAt: '2024-02-07',
		},
	],
	mini: [
		{
			title: 'Rick was cordial...',
			stars: 5,
			text: 'The representative was cordial and explained how the charges were broken down for the rental. We were only looking for a small unit, so before we committed, he showed us the two smallest units and let us decide which would meet our needs.',
			customerName: 'Thomas Crossman',
			createdAt: '2025-07-08',
		},
		{
			title: 'Easy and affordable pricing',
			stars: 5,
			text: 'Easy and affordable pricing - so good it made me leave another storage facility charging me the same for a 5x5 that you were offering for the same price!',
			customerName: 'Jarrett S',
			createdAt: '2024-09-17',
		},
		{
			title: 'Very easy and convenient',
			stars: 5,
			text: 'Very easy and convenient. I was able to compare costs and locations of various facilities with available 5x5 spaces, then all I had to do was enter my name and cell phone number to book it.',
			customerName: 'Jim Saco',
			createdAt: '2022-01-07',
		},
		{
			title: 'I loved the experience',
			stars: 5,
			text: 'I loved the experience. It was a great price for a 5x5 unit and the process was smooth!',
			customerName: 'Ramono Truesdale',
			createdAt: '2019-09-21',
		},
	],
	small: [
		{
			title: 'Excellent quote on 5x5',
			stars: 5,
			text: 'Excellent quote on 5x5. Quick paperwork and move in with a free lock!',
			customerName: 'Kristen Williams',
			createdAt: '2019-07-22',
		},
		{
			title: 'Great customer service',
			stars: 5,
			text: 'Great customer service! We have a little 5x5, but it is the perfect size! The ladies in the office were so helpful, and were great to work with. 10/10 would recommend people here.',
			customerName: 'Jarrett S',
			createdAt: '2018-11-18',
		},
		{
			title: "Didn't know I needed this",
			stars: 5,
			text: "I do my due diligence. Whenever I'm looking for a product (in this case, a storage unit), I always look for the best quality and price. I reserved with a branded storage place at the BEST possible price. Average prices for a 5x10 were around $100 or more, but I was able to reserve a unit for $76/mo with a first-month half-off deal.",
			customerName: 'Andre Bucknor',
			createdAt: '2022-05-15',
		},
		{
			title: 'I loved the experience',
			stars: 5,
			text: 'I loved the experience. It was a great price for a 5x5 unit and the process was smooth!',
			customerName: 'Ramono Truesdale',
			createdAt: '2019-09-21',
		},
	],
	medium: [
		{
			title: 'It took less than 5 minutes',
			stars: 5,
			text: 'It took less than 5 minutes to see all available 10x10 storage units in my city and pick the best price and location. I moved my belongings to the unit I reserved the same day. The reservation worked — I had no issues! Moving is awful, but this website saved me so much time.',
			customerName: 'Maria Gillespie',
			createdAt: '2025-06-04',
		},
		{
			title: 'There are so many self storage units in…',
			stars: 5,
			text: 'There are so many self-storage units in the area, and most are full. SelfStorage had exactly what I was looking for: a 10x10 unit, a much-needed elevator, and a very good discount.',
			customerName: 'Foster Gail',
			createdAt: '2023-06-19',
		},
		{
			title: 'Needed a storage unit that day',
			stars: 5,
			text: 'Needed a storage unit that day. Went online and found a 10x10 unit for a great price and was able to reserve it, pay for it online, get the unit number and code for the gate and doors, and make my first load within an hour.',
			customerName: 'Robin K',
			createdAt: '2023-03-26',
		},
		{
			title: 'Super nice staff',
			stars: 5,
			text: 'Super nice staff! Very helpful and patient! I reserved a 10x10 and realized it was too small, and it took just a couple of minutes to change everything and get a nice 10x15. Very nice and quiet, newer storage built in 2019. I highly recommend using them if you ever need to rent a storage unit.',
			customerName: 'Marisol Cueva',
			createdAt: '2022-09-26',
		},
	],
	large: [
		{
			title: 'Reserving my unit 10x20 was such a…',
			stars: 5,
			text: 'Reserving my 10x20 unit was such a pleasant experience. It was so easy. I just scrolled through the webpage until I found the unit I needed, filled out the easy, short form, and hit OK. It was done, and no credit or debit card was needed to reserve. Then I got a confirmation email with complete instructions, followed by a call to make sure everything went well with my order.',
			customerName: 'William Hanner',
			createdAt: '2023-09-08',
		},
		{
			title: '10x20 storage',
			stars: 5,
			text: 'Was looking for a 10x20 storage unit for a car all over the Kansas City area, and they had the best deal. Super friendly and helpful staff at the local storage.',
			customerName: 'Carl Bahr',
			createdAt: '2020-02-09',
		},
		{
			title: 'Affordable rates, friendly service, clean units!',
			stars: 5,
			text: "I'm really impressed with the quality of the storage! The manager is friendly and funny, and resolved all of my concerns and answered all of my questions. We even got a free lock for setting up a reservation online! This is also by far the best price I have found for a 10x30 storage unit in the area — better by $40/month than the competition!",
			customerName: 'Henry Paul',
			createdAt: '2016-06-23',
		},
		{
			title: 'Selfstorage.com is a great source',
			stars: 5,
			text: 'SelfStorage.com was able to find a facility that had a 10x30 storage unit available where and when we needed it. They are able to hold the unit until needed without extra cost. They made the shopping experience easy.',
			customerName: 'Roger Scott Bland',
			createdAt: '2014-04-09',
		},
	],
	lockers: [
		{
			title: 'We had a great experience',
			stars: 5,
			text: 'We had a great experience checking in and getting a locker that was suitable for us. The lady at the counter was very informative and made the whole process go very smoothly. I highly recommend this location.',
			customerName: 'Nancy Harris',
			createdAt: '2025-07-16',
		},
		{
			title: 'It was way simple to sign up and…',
			stars: 5,
			text: 'It was way simple to sign up and reserve my locker for when I need to start moving stuff into it.',
			customerName: 'Connie Parker',
			createdAt: '2024-12-19',
		},
		{
			title: 'Awesome place.',
			stars: 5,
			text: 'Fast, efficient, and very nice. Only a few minutes to set up and reserve a locker. Numerous locations, so I was able to get one close to home.',
			customerName: 'Patricia Burl',
			createdAt: '2024-08-28',
		},
		{
			title: 'SelfStorage.com Best Place to Save!',
			stars: 5,
			text: 'I highly recommend this site! I found a storage locker nearby for over $30.00 off the original price!',
			customerName: 'Valerie Hall',
			createdAt: '2023-06-17',
		},
	],
	boat: [
		{
			title: 'Wonderful customer service',
			stars: 5,
			text: 'Wonderful customer service. The representative was so helpful in finding us an appropriately configured unit, as well as expediting the process so that we could get our new boat stored ahead of bad weather.',
			customerName: 'Jeff',
			createdAt: '2020-01-11',
		},
		{
			title: 'Stored my boat',
			stars: 5,
			text: 'SelfStorage.com was the second storage company I called. Their price was much better, and they had a space available immediately. There was no issue signing up. My boat was stored in no time, and everyone was very helpful and friendly.',
			customerName: 'Jack',
			createdAt: '2019-09-05',
		},
		{
			title: 'Easy Transaction Plenty of Space',
			stars: 5,
			text: "Was able to reserve a unit over the phone. Was given an access code to allow me to get my boat stored that evening, as I couldn't get there before they closed. Very nice lady and very accommodating. Prices were comparable to those in the area. Would recommend.",
			customerName: 'Kurt Maassen',
			createdAt: '2019-06-19',
		},
		{
			title: 'Responsible for finding the perfect spot to store my boat',
			stars: 5,
			text: 'This service is fantastic because it allows me to look at many storage options in my area from a single point. The service allowed me to find the perfect spot to store my boat.',
			customerName: 'Leon Milnes',
			createdAt: '2019-06-03',
		},
	],
	car: [
		{
			title: '5 star',
			stars: 5,
			text: '5 stars. I spoke to a very helpful staff member. Selecting and booking our car storage space was easy.',
			customerName: 'Keri R',
			createdAt: '2025-10-21',
		},
		{
			title: 'A1 Service',
			stars: 5,
			text: 'SelfStorage was very helpful with finding the right size storage for my car. I was sent an email with move-in details, and they gave me a follow-up call to see if I had additional questions. Great service.',
			customerName: 'Terrence Hinkson',
			createdAt: '2024-04-01',
		},
		{
			title: 'User friendly perfect storage for my car',
			stars: 5,
			text: 'It was very user-friendly. The staff member who helped me was very nice, and the facility looks great. I feel fortunate to have found such a professional place.',
			customerName: 'Rudi',
			createdAt: '2024-01-18',
		},
		{
			title: 'Best value & Very polite and informative responder.',
			stars: 5,
			text: 'Very polite and informative. Best value for the storage of a car. Convenient location. They hold a reservation without a deposit. Manager on site, well-secured storage area.',
			customerName: 'Leon Milnes',
			createdAt: '2023-11-20',
		},
	],
	rv: [
		{
			title: 'The two associates we worked with were…',
			stars: 5,
			text: 'The two associates we worked with were very friendly, knowledgeable, and helpful! Plus, the spot we got for our RV is very convenient, and the price was extremely competitive. Thank you!',
			customerName: 'Kristi Lawson',
			createdAt: '2025-02-19',
		},
		{
			title: 'Good experience',
			stars: 5,
			text: 'I started my reservation online. Before I was done, I received a phone call from an agent to further help me through the registration. She was kind, helpful, and clear-spoken. Once I had finished the phone call, I went to the facility to learn more and find our site. We were greeted by the facility director, Jessica. She was very pleasant and helpful.',
			customerName: 'Scott',
			createdAt: '2024-12-22',
		},
		{
			title: 'Went out of their way to help',
			stars: 5,
			text: 'Went out of their way to help an old man find a place for his RV. Very, very patient and understanding — great customer service.',
			customerName: 'Joseph Myron Clark',
			createdAt: '2024-06-27',
		},
		{
			title: 'Great Service-Great Location',
			stars: 5,
			text: 'The staff was very friendly and helpful; they answered all my questions and explained all the rules and policies. I rented an RV parking space at a great price and was given the choice of selecting any open space I wanted. The location is great — I am only 5 minutes away.',
			customerName: 'Oscar Molina',
			createdAt: '2023-09-02',
		},
	],
	deals: [
		{
			title: 'Downhome Friendly, Affordable pricing, Personable Service',
			stars: 5,
			text: 'It was a pleasure to find a local, in-town rental facility that had climate-controlled units available on SelfStorage. The property and the units are VERY clean and the grounds are well-kept. The pricing was as good as some non-climate-controlled units in the area. The 24-hour access is way better than most in the area. In all my many years of having to use rental units on occasion, this was by far one of the best.',
			customerName: 'Rickie Parker RevDRx',
			createdAt: '2025-02-17',
		},
		{
			title: 'Wonderful',
			stars: 5,
			text: 'The gentleman who answered the phone for SelfStorage and rented me the storage unit was one of the nicest, most helpful people I have ever dealt with. I definitely recommend this company. He was able to get me a larger unit than I planned, and it cost less in the end. I also love the 24/7 access... gotta have it!',
			customerName: 'Amber M Aracich',
			createdAt: '2025-03-16',
		},
		{
			title: 'Competitive Pricing!',
			stars: 5,
			text: 'Finally, a storage unit that is budget-friendly! Love the fact that they have 24-hour accessibility!',
			customerName: 'Tim Beber',
			createdAt: '2024-06-03',
		},
		{
			title: 'Very friendly service',
			stars: 5,
			text: 'Very friendly service. Clean and safe. What I like the most is 24/7 access to the facility, not like most others with time limits. Good prices.',
			customerName: 'S Drummer',
			createdAt: '2022-08-23',
		},
	],
};

export default nmpReviews;
